import React from 'react';
import {
  Box,
  Container,
  VStack,
} from '@chakra-ui/react';
import ForgotPasswordForm from '../components/ForgotPasswordForm';

const ForgotPasswordView = ({ onForgotPasswordSubmit }) => {

  return (
    <Container maxW="container.md" py={10}>
      <VStack spacing={8} align="center">
        <Box w="100%" maxW="400px">
          <ForgotPasswordForm onSubmit={onForgotPasswordSubmit} />
        </Box>
      </VStack>
    </Container>
  );
};

export default ForgotPasswordView;
